import _ from 'lodash';
import React from 'react';
import PropTypes from 'prop-types';
import Radium from 'radium';
import loadjs from 'loadjs';

import * as styles from '../styles';
import {request} from '../containers/actions';
import {imageUrl} from '../utilities/requests';
import { host_v2 } from '../utilities/requests';

// //@Radium
export default class Content extends React.Component {
    static contextTypes = {
        store: PropTypes.object,
        user: PropTypes.object,
    }

    static defaultProps = {
        errors: [],
        style: {},
        onInit: () => null,
        onFocusin: () => null,
        onFocusout: () => null,
        onChange: () => null,
        onTitleChange: () => null,
        onURIChange: () => null,
        onPublishedChange: () => null,
        onLinkClicked: undefined,
        inline: true,
        tinymceConfig: {},
        style: {},
        preview: false,
        uploadImages: true,
        uploadAudio: true,
        embedImages: false,
    }

    state = {
        title: this.props.title,
        uri: this.props.uri,
        published: this.props.published,
        edit: !this.props.preview,
    }

    componentDidMount() {
        this.mounted = true;
    }

    componentWillUnmount() {
        this.mounted = false;
    }

    componentWillReceiveProps(nextProps) {
        if (nextProps.title !== this.props.title)
            this.setState({title: nextProps.title});
        if (nextProps.uri !== this.props.uri)
            this.setState({uri: nextProps.uri});
        if (nextProps.published !== this.props.published)
            this.setState({published: nextProps.published});
        if (nextProps.uploadImages !== this.props.uploadImages)
            this.editor.uploadImages = nextProps.uploadImages;
        if (nextProps.uploadAudio !== this.props.uploadAudio)
            this.editor.uploadAudio = nextProps.uploadAudio;
        if (nextProps.embedImages !== this.props.embedImages)
            this.editor.embedImages = nextProps.embedImages;
    }

    componentDidUpdate(prevProps) {
        if (
            prevProps.content !== undefined && prevProps.content !== this.props.content &&
            this.editor && this.editor.getBody() && this.editor.getBody().innerHTML !== this.props.content
        ) {
            const content = (this.props.content || '').replace(/ id="MathJax[^"]*"/g, '');
            this.editor.getBody().innerHTML = content;
        }
    }

    async uploadImage(image) {
        console.log("eddfef")
        if (!this.props.uploadImages)
            return;
        try {
            const response = await this.context.store.dispatch(request({
                path: '/image/',
                body: window.toFormData({
                    image: image.file,
                }),
                method: 'POST',
            }));
            image.src = imageUrl(response.uuid, {});
        }
        catch (exception) {
            image.remove();
        }
    }
    async uploadAudio(audio) {
        try{
            var token = this.context.store.getState().get('application').get('token');
            console.log("token", token)
            const formData = new FormData();
            formData.append('audio', audio.file);
            console.log("asdf",host_v2)
            const res = await fetch(`${host_v2}/api/MediaApi/SaveAudioInBucket`, {
                method: 'POST',
                headers: {
                    'Accept': 'application/json',
                    "Authorization": `${token.get('tokenType')} ${token.get('accessToken')}`
                },
                body: formData
            });
            const response = await res.json();
            if(response.errorId == 0){
                audio.src = response.result;
            }else{
                audio.remove();
            }
        }catch(exception){
            audio.remove();
        }        
    }

    renderContent() {
        if (this.props.content !== undefined) {
            return <div style={{
                ...this.props.style,
                position: 'relative',
            }}>
                {!this.props.readonly && this.props.preview
                    ? <button
                        style={{
                            ...styles.button,
                            position: 'absolute',
                            top: this.state.edit ? '-3em' : '-.5em',
                            right: '50%',
                            transform: 'translateX(50%)',
                            opacity: '.3',
                            zIndex: '5',
                            cursor: 'pointer',
                            minWidth: 'unset',
                            ':hover': {
                                opacity: '1',
                            },
                        }}
                        onClick={() => this.setState({edit: !this.state.edit})}>
                        <i className='fa-pencil fa-lg'/>
                    </button>
                    : null
                }
                {(() => {
                    if (!this.state.edit || this.props.readonly) {
                        return <div
                            key='content'
                            className='content content-preview'
                            style={{
                                width: '100%',
                                border: 'none',
                                ...styles.content,
                            }}
                            dangerouslySetInnerHTML={{__html: this.props.content}}
                            onClick={this.props.onLinkClicked}
                        />;
                    }
                    else {
                        if (!window.tinymce) {
                            if (window.loadingTinyMCE) {
                                setTimeout(this.forceUpdate.bind(this), 1000);
                                return <div>{window.gettext('Loading')}...</div>;
                            }
                            window.loadingTinyMCE = true;
                            loadjs(window.hashed_paths['js/tinymce.min.js'], 'tinymce', {
                                success: () => {
                                    if (this.mounted)
                                        this.setState({tinyMCEInitialized: true});
                                    setTimeout(() => {
                                        var metas = document.getElementsByTagName('meta');
                                        for(var i = 0 ; i<metas.length ; i++)
                                        {
                                            if(metas[i].name == 'viewport')
                                                metas[i].content = 'width=device-width, initial-scale=1.0'
                                        }
                                        // console.log("meta changed");
                                    }, 1000);
                                },
                            });
                            return <div>{window.gettext('Loading')}...</div>;
                        }
                        this.TinyMCE = this.TinyMCE || require('./tinymce').default;
                        const TinyMCE = this.TinyMCE;
                        return <span>
                            <div style={{
                                border:`${this.context.user.hasPerm('examination.edit') && "1px solid #eaeaea"}`,
                                borderRadius:"3px"
                            }}>
                            <TinyMCE
                                key='tinymce'
                                config={{
                                    ...require('../utilities/tinymce').tinyMCEConfig,
                                    ...this.props.tinymceConfig,
                                    inline: this.props.inline,
                                    height: this.props.height,
                                }}
                                id={this.props.id}
                                onInit={(__, editor) => {
                                    this.editor = editor;
                                    editor.uploadImages = this.props.uploadImages;
                                    editor.embedImages = this.props.embedImages;
                                    editor.uploadImage = this.uploadImage.bind(this);
                                    editor.uploadAudio = this.uploadAudio.bind(this)
                                    editor.getBody().classList.add('content');
                                    editor.getBody().classList.add('edit');
                                    if (editor === window.tinymce.activeEditor)
                                        editor.getBody().classList.add('content-preview');
                                    editor.getBody().style.overflow = 'hidden';
                                    const content = this.props.content || '';
                                    editor.getBody().innerHTML = content.replace(/ id="MathJax[^"]*"/g, '').replace(/<p><\/p>/, '');
                                    if (editor.getWin() !== window.top.window) {
                                        editor.getWin().Element.prototype.formula = function(callback) {
                                            if (!this.dataset.code)
                                                return this;
                                            const formulaElement = this.cloneNode(true);
                                            window.top.document.body.appendChild(formulaElement);
                                            window.Element.prototype.formula.bind(formulaElement)(() => {
                                                this.replaceWith(formulaElement);
                                                if (callback)
                                                    callback(arguments);
                                            });
                                            return formulaElement;
                                        };
                                    }
                                    setTimeout(
                                        () => this.mounted
                                            ? this.props.onInit(editor, editor.getBody().innerHTML, editor.getBody().innerText)
                                            : null,
                                        0,
                                    );
                                }}
                                onFocusin={(__, editor) => {
                                    editor.getBody().classList.remove('content-preview');
                                    this.props.onFocusin();
                                }}
                                onFocusout={(__, editor) => {
                                    editor.getBody().classList.add('content-preview');
                                    this.props.onFocusout(editor.getBody().innerHTML, editor.getBody().innerText);
                                }}
                                onChange={_.throttle((__, editor) => {
                                    this.props.onChange(editor.getBody().innerHTML, editor.getBody().innerText);
                                }, 1000)}
                                onNodeChange={(event, editor) => {
                                    this.props.onChange(editor.getBody().innerHTML, editor.getBody().innerText);
                                    _.forEach(
                                        editor.getBody().querySelectorAll('.formula'),
                                        formulaElement => {
                                            if (formulaElement.innerText[0] === '`') {
                                                formulaElement.formula();
                                            }
                                        }
                                    );
                                }}
                                onKeyup={_.throttle((__, editor) => {
                                    this.props.onChange(editor.getBody().innerHTML, editor.getBody().innerText);
                                }, 1000)}
                                onUndo={_.throttle((__, editor) => {
                                    this.props.onChange(editor.getBody().innerHTML, editor.getBody().innerText);
                                }, 1000)}
                                onRedo={_.throttle((__, editor) => {
                                    this.props.onChange(editor.getBody().innerHTML, editor.getBody().innerText);
                                }, 1000)}
                            />
                            </div>
                        </span>;
                    }
                })()}
            </div>;
        }
        else {
            return <div>{window.gettext('Loading')}...</div>;
        }
    }

    render() {
        return <span>
            {!this.props.readonly && this.state.edit
                ? <div style={{overflow: 'auto'}}>
                    <div style={{marginLeft: '.5em', float: 'right', display: this.props.title ? undefined : 'none'}}>
                        <span>
                            {this.props.titleLabel}:&nbsp;
                        </span>
                        <input
                            key='title'
                            style={{...styles.field, marginBottom: 'unset', marginTop: '-.2em', width: 'unset'}}
                            value={this.state.title || ''}
                            onChange={({target: {value}}) => {
                                this.setState({title: value.persian()});
                                this.props.onTitleChange(value);
                            }}
                        />
                        <div style={styles.error}>
                            {this.props.errors && this.props.errors.title
                                ? _.map(
                                    this.props.errors.title,
                                    (error, index) => <li style={{display: 'block'}} key={index}>
                                        * {error}
                                    </li>,
                                )
                                : null
                            }
                        </div>
                    </div>
                    <div style={{marginLeft: '.5em', float: 'right', display: this.props.uri ? undefined : 'none'}}>
                        <span>
                            {window.gettext('URI')}:&nbsp;
                        </span>
                        <input
                            key='uri'
                            style={{...styles.field, marginBottom: 'unset', marginTop: '-.2em', width: 'unset', direction: 'ltr'}}
                            value={this.state.uri || ''}
                            onChange={({target: {value}}) => {
                                this.setState({uri: value});
                                this.props.onURIChange(value);
                            }}
                        />
                        <div style={styles.error}>
                            {this.props.errors && this.props.errors.uri
                                ? _.map(
                                    this.props.errors.uri,
                                    (error, index) => <li style={{display: 'block'}} key={index}>
                                        * {error}
                                    </li>,
                                )
                                : null
                            }
                        </div>
                    </div>
                    {
                        _.map(this.props.actions, (action, index) => <button
                            key={index}
                            style={{
                                ...(action.default ? styles.defaultButton : styles.button),
                                float: 'left',
                                marginRight: '.1em',
                            }}
                            onClick={action.action}>
                            {action.label}
                        </button>)
                    }
                    {this.state.published !== undefined
                        ? <label style={{float: 'left', marginBottom: '.4em', marginTop: '.4em'}}>
                            <input
                                type='checkbox'
                                checked={this.state.published}
                                onChange={({target: {checked}}) => {
                                    this.setState({published: checked});
                                    this.props.onPublishedChange(checked);
                                }}
                            />
                            {window.gettext('Published')}
                        </label>
                        : null
                    }
                </div>
                : null
            }
            {window.location.pathname === '/'?<h2 style={{width:'100%',textAlign:'center', marginTop:'6rem'}}>آزمون تشریحی</h2>:this.renderContent.bind(this)()}
        </span>;
    }
}
